import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const LayoutWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 288px;
  padding: ${Spacing.S40};
  border: 1px solid ${Color.Grey200};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.White};
  grid-column-gap: ${Spacing.S40};
`
